import { Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Page } from 'components/Page';
import { usePermissions } from 'features/permissions';
import { Blacklist } from 'pages/Settings/Blacklist/blacklist';
import { CareerSettings } from 'pages/Settings/Career/career-settings';
import { CareerTheme } from 'pages/Settings/Career/career-theme';
import { CompanySettings } from 'pages/Settings/Company/company-settings';
import { Departments } from 'pages/Settings/departments';
import { Integrations } from 'pages/Settings/integrations';
import { JobBoards } from 'pages/Settings/JobBoards';
import { JobOrdering } from 'pages/Settings/jobOrdering/ordering';
import { Labels } from 'pages/Settings/Labels/labels';
import { Locations } from 'pages/Settings/locations';
import { Profile } from 'pages/Settings/profile';
import { WorkTypes } from 'pages/Settings/WorkTypes/worktypes';
import Team from 'pages/Team';
import TeamDetails from 'pages/Team/team-details';
import Templates from 'pages/templates';
import EditEmailTemplate from 'pages/templates/edit-email-template';
import EditTasklistTemplate from 'pages/templates/edit-tasklist-template';
import EmailTemplates from 'pages/templates/email-templates';
import TasklistTemplates from 'pages/templates/tasklist-templates';

export const CompanySettingsRouteConfig = () => {
  const { hasRolePermission } = usePermissions();

  return (
    <Page>
      <Routes>
        {hasRolePermission('company:view-settings') && (
          <Fragment>
            {hasRolePermission('company:view-career-settings') && (
              <Fragment>
                <Route path="career" element={<CareerSettings />} />
                <Route path="theme" element={<CareerTheme />} />
              </Fragment>
            )}
            {hasRolePermission('company:details-settings') && (
              <Route path="company/*" element={<CompanySettings />} />
            )}
            <Route path="departments/*" element={<Departments />} />
            <Route path="worktypes/*" element={<WorkTypes />} />
            <Route path="locations/*" element={<Locations />} />
            <Route path="jobboards/*" element={<JobBoards />} />
            <Route path="spamProtection/*" element={<Blacklist />} />
            <Route path="jobordering/*" element={<JobOrdering />} />
            <Route path="labels/*" element={<Labels />} />
            <Route path="apps/*" element={<Integrations />} />
            {hasRolePermission('company:edit-templates') && (
              <Fragment>
                <Route path="templates/emails/:templateID" element={<EditEmailTemplate />} />
                <Route path="templates/tasks/:templateID" element={<EditTasklistTemplate />} />
              </Fragment>
            )}
            {hasRolePermission('company:view-templates') && (
              <Route path="templates/*" element={<Templates />}>
                <Route path="emails/*" element={<EmailTemplates />} />
                <Route path="tasks/*" element={<TasklistTemplates />} />
                <Route path="*" element={<Navigate to="emails" replace />} />
              </Route>
            )}
            {hasRolePermission('team:view') && (
              <Route path="team/*">
                <Route index element={<Team />} />
                <Route path=":id/:section" element={<TeamDetails />} />
              </Route>
            )}
          </Fragment>
        )}
        <Route path="profile/*" element={<Profile />} />
        <Route
          path="*"
          element={
            <Navigate
              to={hasRolePermission('company:view-settings') ? 'team' : 'profile/details'}
              replace
            />
          }
        />
      </Routes>
    </Page>
  );
};
